import { KYMW00Model } from '../kymw00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from '../pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品ロック情報を取得する
 *
 * @export API通信成功時の処理
 * @class GoodsLockService
 * @extends {PlessResponder}
 */
@Injectable()
export class GoodsLockService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW00Model = null;
  private vo: any = null;
  private successFunction: Function = null;
  private lockType: string = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GoodsLockService
   */
  private getBodyRegist(): PlessRequest {
    return new PlessRequest({
      parameter: {
        FormId: this.vo.formId,
        UserId: this.vo.userId,
        CheckOnly: this.vo.checkOnly
      },
      regist: {
        GoodsLock: {
          combination: [
            {
              parameter: {
                  PCode: this.vo.pCode,
              }
            }
          ]
        }
      }
    });
  }

  /**
 * bodyにセットする値を返す
 *
 * @private
 * @returns {PlessRequest} リクエストJSON
 * @memberof GoodsLockService
 */
  private getBodyRelease(): PlessRequest {
    return new PlessRequest({
      parameter: {
        FormId: this.vo.formId,
        UserId: this.vo.userId ? this.vo.userId.trim() : this.vo.userId,
      },
      delete: {
        GoodsLock: {
          combination: [
            {
              parameter: {
                PCode: this.vo.pCode,
              }
            }
          ]
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW00Model} model モデルクラス
   * @param {*} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof GoodsLockService
   */
  execute(model: KYMW00Model, vo: any, type: string) {
    this.model = model;
    this.vo = vo;
    if (type === model.EVENT_LOCK_PLAN_GOODS_REGIST) {
      this.lockType = 'REGIST';
      this.send('KYMW02registGoodsLock', this.getBodyRegist());
    } else if (type === model.EVENT_LOCK_PLAN_GOODS_RELEASE) {
      this.lockType = 'RELEASE';
      this.send('KYMW02releaseGoodsLock', this.getBodyRelease());
    } else {
      this.lockType = 'CHECK';
      this.send('KYMW02checkGoodsLock', this.getBodyRegist());
    }
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof GoodsLockService
   */
  success(_: any) {
    if (this.lockType === 'REGIST') {
      // ロック登録に成功した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
      if (this.vo.viewControl === true) {
        this.vo.viewHelper.setScreenMode(this.model.kymw1001Model.setScreenModeOnNowFunc(this.model.kymw1001Model.topFuncID));
      }
    } else if (this.lockType === 'RELEASE') {
      // ロック解除に成功した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
    }

    if (this.vo.successFunc != null) {
      this.vo.successFunc(this.vo.successParam);
    }
  }

  /**
   * API通信失敗時処理
   *
   * @param {*} _
   * @memberof GoodsLockService
   */
  lockErrorHandler(_: any): void {
    if (this.lockType === 'REGIST') {
      // ロック登録に失敗した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, true);

      if (this.vo.viewControl === true) {
        this.vo.viewHelper.setScreenMode('true');
      }
    } else if (this.lockType === 'RELEASE') {
      // ロック解除に失敗した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
    }

    if (this.vo.faultFunc != null) {
      this.vo.faultFunc(this.vo.faultParam);
    }
  }

}
